import React, { useState, useCallback } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
// import AwsConfig from '../../Config/AwsConfig'
import UpdatePointsToMovieOrPerson from '../../Services/Mutations/UpdatePointsToMovieOrPerson'
import { toast } from 'react-toastify'
import { debounce } from 'lodash'
import { Button } from 'react-bootstrap'
import { useEffect } from 'react'

function DisplayImagepointsAndpeorid({
  // imageSrc,
  title,
  initialPoints,
  id,
  onRemove,
  selectedContentType,
  AutoSuggestionSelectedOption,
  manuallyUpdatedTrendingData,
  // type,
  index,
  items,
  handleItems,
}) {
  const [points, setPoints] = useState(initialPoints)
  useEffect(() => {
    setPoints(initialPoints)
  }, [initialPoints])

  const handlePointsChange = useCallback(
    async inputValue => {
      const contentType = selectedContentType === 'person' ? 'persons' : selectedContentType
      const input = {
        contentType,
        id,
        recordType: AutoSuggestionSelectedOption,
        points: inputValue,
      }

      try {
        const updateResult = await UpdatePointsToMovieOrPerson(input)
        if (updateResult && updateResult.statusCode === '200') {
          toast.success('Points updated successfully!')
        } else {
          toast.error('Failed to update points. Please try again.')
        }
      } catch (error) {
        toast.error(error.message)
      }
    },
    [selectedContentType, id, AutoSuggestionSelectedOption],
  ) // Include all dependencies of handlePointsChange

  const debouncedHandlePointsChange = useCallback(debounce(handlePointsChange, 2000), [
    handlePointsChange,
  ])

  const handleInputChange = event => {
    const inputValue = parseInt(event.target.value, 10)
    setPoints(inputValue)
    debouncedHandlePointsChange(inputValue)
  }

  const stopWheelAction = event => {
    event.target.blur()
    event.preventDefault()
    event.stopPropagation()
  }

  const handleRemove = () => {
    // if (onRemove) {
    console.log(id, 'id==========')
    onRemove(id) // Pass the id to the callback function
    // }
  }

  const moveItemDown = index => {
    // handleMoveItem('down', dataIndex)
    // setvalueEdited(true)
    const itemsTemp = [...items]
    const itemtemp = itemsTemp[index + 1]
    itemsTemp[index + 1] = itemsTemp[index]
    itemsTemp[index] = itemtemp
    handleItems(itemsTemp)
  }

  const moveItemUp = index => {
    // handleMoveItem('up', dataIndex)
    // setvalueEdited(true)
    const itemsTemp = [...items]
    const itemtemp = itemsTemp[index - 1]
    itemsTemp[index - 1] = itemsTemp[index]
    itemsTemp[index] = itemtemp
    handleItems(itemsTemp)
  }

  return (
    <div style={{ width: '100%' }}>
      {/* Adjusted to fit four components in a row */}
      <div
        className='card position-relative'
        style={{
          minHeight: manuallyUpdatedTrendingData ? '50px' : '150px',
          maxHeight: manuallyUpdatedTrendingData ? '50px' : '150px',
        }}
      >
        <div className='row' style={{ flexWrap: 'nowrap' }}>
          <div>
            {/* <img
              src={
                imageSrc ||
                AwsConfig.movieCdnUrl + AwsConfig.avatharPath + AwsConfig.personStaticImage
              }
              className='card-img-top img-fluid'
              alt='Example'
              style={{ minHeight: '200px', maxHeight: '200px', objectFit: 'cover' }}
            /> */}
            <div
              className='d-flex'
              style={{ justifyContent: 'space-around', alignItems: 'center' }}
            >
              <div className='card-text'>
                {/* {`${
                  type === 'webseries'
                    ? 'webseries ID'
                    : type === 'movies'
                    ? 'Movie ID'
                    : 'Person ID'
                }`}
                : */}
                {id}
              </div>
              <div className='card-title'>
                {/*  {`${
                  type === 'webseries'
                    ? 'webseries Name'
                    : type === 'movies'
                    ? 'Movie Name'
                    : 'Person Name'
                }`}
                : */}
                {title || 'test'}
              </div>
            </div>
          </div>
          {manuallyUpdatedTrendingData ? (
            // <button
            //   className='btn btn-danger position-absolute top-0 end-0 m-2'
            //   type='button'
            //   style={{ zIndex: '1' }}
            //   onClick={handleRemove}
            // >
            //   X
            // </button>
            <div
              className='d-flex justify-content-center align-items-center'
              style={{ width: '10%' }}
            >
              <Button
                variant='danger'
                className='btn-sm mr-1 ml-1'
                onClick={() => handleRemove(id)}
              >
                <i className='fa fa-times' />
              </Button>
              {index !== 0 && (
                <Button
                  variant='primary'
                  className='btn-sm mr-1 ml-1'
                  onClick={() => moveItemUp(index)}
                >
                  <i className='fa  fa-angle-double-up' />
                </Button>
              )}
              {index !== items.length - 1 && (
                <Button
                  variant='primary'
                  className='btn-sm mr-1 ml-1'
                  onClick={() => moveItemDown(index)}
                >
                  <i className='fa  fa-angle-double-down	' />
                </Button>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
        {manuallyUpdatedTrendingData ? (
          <></>
        ) : (
          <div className='card-body'>
            <div className='card-text'>
              Points:
              <input
                type='number'
                className='form-control'
                value={points}
                onChange={event => handleInputChange(event)}
                onWheel={event => stopWheelAction(event)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DisplayImagepointsAndpeorid
